(() => {
  const SELECTORS = {
    banner: '[data-free-shipping-banner]',
    message: '[data-free-shipping-message]',
    progress: '[data-free-shipping-progress]',
    bar: '[data-free-shipping-bar]',
  };

  let updateTimer;
  let requestInProgress = false;
  let updateRequestedAgain = false;

  function getCartUrl() {
    const root = window.Shopify?.routes?.root || '/';
    return `${root}cart.js`;
  }

  function formatMoney(amount, currency = 'GBP') {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
      style: 'currency',
      currency,
    }).format(amount / 100);
  }

  function updateBannerElement(banner, cart) {
    const threshold = Number(banner.dataset.threshold || 2000);
    const total = Number(cart.total_price || 0);
    const remaining = Math.max(threshold - total, 0);
    const percentage = Math.min((total / threshold) * 100, 100);

    const message = banner.querySelector(SELECTORS.message);
    const progress = banner.querySelector(SELECTORS.progress);
    const bar = banner.querySelector(SELECTORS.bar);

    const newMessage =
      total >= threshold
        ? "You've unlocked free shipping!"
        : `Add ${formatMoney(remaining, cart.currency || 'GBP')} more to get free shipping.`;

    if (message && message.textContent.trim() !== newMessage) {
      message.textContent = newMessage;
    }

    if (bar) {
      const newWidth = `${percentage}%`;

      if (bar.style.width !== newWidth) {
        bar.style.width = newWidth;
      }
    }

    if (progress) {
      progress.setAttribute(
        'aria-valuenow',
        String(Math.min(total, threshold))
      );
    }
  }

  async function refreshFreeShippingBanner() {
    const banners = document.querySelectorAll(SELECTORS.banner);

    if (!banners.length) return;

    if (requestInProgress) {
      updateRequestedAgain = true;
      return;
    }

    requestInProgress = true;

    try {
      const response = await fetch(getCartUrl(), {
        method: 'GET',
        headers: {
          Accept: 'application/json',
        },
        credentials: 'same-origin',
        cache: 'no-store',
      });

      if (!response.ok) {
        throw new Error(`Cart request failed: ${response.status}`);
      }

      const cart = await response.json();

      document
        .querySelectorAll(SELECTORS.banner)
        .forEach((banner) => updateBannerElement(banner, cart));
    } catch (error) {
      console.error('Free-shipping banner could not update.', error);
    } finally {
      requestInProgress = false;

      if (updateRequestedAgain) {
        updateRequestedAgain = false;
        scheduleUpdate(250);
      }
    }
  }

  function scheduleUpdate(delay = 200) {
    window.clearTimeout(updateTimer);
    updateTimer = window.setTimeout(refreshFreeShippingBanner, delay);
  }

  /*
   * Refresh after quantity buttons, remove buttons,
   * quantity inputs or add-to-cart forms are used.
   */
  document.addEventListener(
    'click',
    (event) => {
      if (
        event.target.closest(
          'quantity-input, cart-remove-button, [name="plus"], [name="minus"], .quantity__button'
        )
      ) {
        scheduleUpdate(350);
      }
    },
    true
  );

  document.addEventListener(
    'change',
    (event) => {
      if (
        event.target.matches(
          'input[name="updates[]"], .quantity__input, cart-drawer input[type="number"]'
        )
      ) {
        scheduleUpdate(350);
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      if (
        event.target.matches(
          'form[action*="/cart/add"], product-form form'
        )
      ) {
        scheduleUpdate(500);
      }
    },
    true
  );

  /*
   * Refresh when Shopify replaces cart drawer/cart page HTML.
   * This covers theme-generated Ajax updates.
   */
  const observer = new MutationObserver((mutations) => {
    const cartChanged = mutations.some((mutation) => {
      const target = mutation.target;

      return (
        target instanceof Element &&
        (
          target.closest(
            'cart-drawer, cart-items, cart-drawer-items, #main-cart-items, #CartDrawer'
          ) ||
          Array.from(mutation.addedNodes).some(
            (node) =>
              node instanceof Element &&
              node.matches?.(
                'cart-drawer, cart-items, cart-drawer-items, #main-cart-items, #CartDrawer, [data-free-shipping-banner]'
              )
          )
        )
      );
    });

    if (cartChanged) {
      scheduleUpdate(250);
    }
  });

  function initialise() {
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    refreshFreeShippingBanner();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise);
  } else {
    initialise();
  }
})();